// extracted by mini-css-extract-plugin
module.exports = {"nav-outlet-link":"_316TqwL3U0n8bEwRqLLhkc","text-block-center":"_339a7i5TacHv5UY0vHxiAF","nav-outlet-wrapper":"_3qYg-IHCsW0jr-gd9eD6AL"};